import { useState, useEffect } from 'react'
import { API_BASE_URL } from '../utils/config'

export const useAuth = () => {
  const [user, setUser] = useState(() => {
    // localStorage에서 사용자 정보 복원
    const savedUser = localStorage.getItem('user')
    return savedUser ? JSON.parse(savedUser) : null
  })
  const [loading, setLoading] = useState(false)
  const [session, setSession] = useState(() => {
    // localStorage에서 토큰 확인
    const token = localStorage.getItem('access_token')
    return token ? { accessToken: token } : null
  })

  // API_BASE_URL은 이미 import됨 (상단에서)

  // 토큰 유효성 검증 및 사용자 정보 갱신
  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem('access_token')
      if (!token) return

      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/supabase/user`, {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        })

        if (response.ok) {
          const userData = await response.json()
          setUser(userData)
          localStorage.setItem('user', JSON.stringify(userData))
        } else if (response.status === 401) {
          // 토큰이 만료되었거나 유효하지 않음
          signOut()
        }
      } catch (error) {
        console.error('토큰 검증 실패:', error)
      }
    }

    verifyToken()
  }, [])

  // 로그아웃
  const signOut = async () => {
    try {
      const token = localStorage.getItem('access_token')
      
      if (token) {
        // Supabase 로그아웃 API 호출 (선택적 - 서버 세션 정리용)
        try {
          await fetch(`${API_BASE_URL}/api/auth/supabase/logout`, {
            method: 'POST',
            headers: {
              'Authorization': `Bearer ${token}`
            }
          })
        } catch (error) {
          // 로그아웃 API 실패해도 로컬 정리는 진행
          console.error('로그아웃 API 호출 실패:', error)
        }
      }

      // 로컬 데이터 삭제
      localStorage.removeItem('user')
      localStorage.removeItem('access_token')
      
      // 모든 프로젝트 관련 로컬 데이터도 선택적으로 삭제
      // localStorage.removeItem(`projects_${user?.id}`)
      
      setUser(null)
      setSession(null)
      
      // 로그아웃 성공 메시지 (선택적)
      console.log('로그아웃 되었습니다.')
      
      // 페이지 새로고침
      window.location.reload()
    } catch (error) {
      console.error('로그아웃 중 오류:', error)
      // 오류가 발생해도 로컬 데이터는 삭제
      localStorage.removeItem('user')
      localStorage.removeItem('access_token')
      window.location.reload()
    }
  }

  // API 요청을 위한 헤더 생성
  const getAuthHeaders = () => {
    const token = localStorage.getItem('access_token')
    return token ? {
      'Authorization': `Bearer ${token}`
    } : {}
  }

  return {
    user,
    session,
    loading,
    signOut,
    getAuthHeaders,
    isAuthenticated: !!user
  }
}